<template>
  <div class="configurationList">
    <div class="configurationList_selectionArea">
      <el-input v-model="parameter.customer_name" placeholder="请输入客服名称" style="width: 200px; " />
      <el-input v-model="parameter.equipment_code" placeholder="请输入手机设备编码" style="width: 200px; " />
      <el-input v-model="parameter.phone_vx_account" placeholder="请输入微信号" style="width: 200px; " />
      <el-input v-model="parameter.phone_name" placeholder="请输入手机编号" style="width: 200px; " />
      <el-input v-model="parameter.key_word" placeholder="关键字" style="width: 200px; " />
      <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      <el-button type="info" icon="el-icon-refresh-right" @click="reset">重置</el-button>

      <!-- <el-button type="primary" icon="el-icon-plus" @click="dialogVisible = true">创建</el-button> -->
    </div>
    <div class="configurationList_main">
      <el-table
        v-loading="loading"
        :data="tableData.list"
        border
        style="width: 100%"
      >
        <el-table-column
          prop="id"
          label="id"
          min-width="100"
          align="center"
        />
        <el-table-column
          prop="customer_name"
          label="客服"
          min-width="120"
          align="center"
        />
        <el-table-column
          prop="equipment_code"
          label="手机设备编码"
          min-width="120"
          align="center"
        />
        <el-table-column
          prop="phone_name"
          label="手机编号"
          min-width="120"
          align="center"
        />
        <el-table-column
          prop="phone_vx_account"
          label="微信号"
          min-width="100"
          align="center"
        />
        <el-table-column
          prop="qrcode_img"
          label="二维码"
          width="180"
          align="center"
        >
          <template scope="scope">
            <el-popover
              placement="right"
              title="详情"
              width="280"
              trigger="hover"
            >
              <img :src="scope.row.qrcode_img" style="width: 250px">
              <img v-if="scope.row.qrcode_img" slot="reference" :src="scope.row.qrcode_img" style="width: 100px; height: 80px">
              <span v-else>暂无</span>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          prop="admin_id"
          label="创建人"
          min-width="100"
          align="center"
        />
        <el-table-column
          prop="key_word"
          label="关键字"
          min-width="100"
          align="center"
        />
        <el-table-column
          prop="created_at"
          label="创建时间"
          min-width="120"
          align="center"
        >
          <template scope="scope">{{ timestampToTime(scope.row.created_at) }}</template>
        </el-table-column>
      </el-table>
      <PaginationRight
        :total="tableData.total"
        @size-change="fetchPageSizeone"
        @current-change="fetchCurrentPageone"
      />
    </div>

    <el-dialog
      :title="Object.keys(currentItem).length ? '修改' : '创建'"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <Details v-if="dialogVisible" :current-item="currentItem" @determine="determine" @close="dialogVisible = false" />
    </el-dialog>
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight'
import Details from './components/details.vue'
import { errorList, errorAdding } from '@/api/enterpriseWeChatCustomerService'
export default {
  components: {
    PaginationRight,
    Details
  },
  data() {
    return {
      parameter: {
        customer_name: null, // 客服名称
        equipment_code: null, // 手机设备编码
        phone_vx_account: null, // 微信号
        phone_name: null, // 手机编号
        key_word: null, // 关键字
        page: 1,
        pageSize: 10
      },
      tableData: {},
      loading: false,
      currentItem: {},
      dialogVisible: false
    }
  },
  created() {
    this.getList()
  },
  methods: {

    async getList() {
      this.loading = true
      const data = await errorList(this.parameter)
      data.data.list = data.data.list.map((item) => { return { ...item, qrcode_img: `${data.data.qiniu_domain + item.qrcode_img}` } })
      this.tableData = data.data
      this.loading = false
    },

    // 删除
    async deleteItem(row) {
      // await mobilePhoneDeletion({ id: row.id })
      this.getList()
      this.$message({
        message: '删除成功',
        type: 'success'
      })
    },

    // 修改
    modifyItem(row) {
      this.currentItem = row
      this.dialogVisible = true
    },

    // 搜索
    search() {
      this.parameter.page = 1
      this.parameter.pageSize = 10
      this.getList()
    },

    // 重置
    reset() {
      this.parameter.page = 1
      this.parameter.pageSize = 10
      this.parameter.equipment_code = null
      this.parameter.phone_vx_account = null
      this.parameter.phone_name = null
      this.parameter.customer_name = null
      this.parameter.key_word = null
      this.getList()
    },

    // 确定
    async determine(form) {
      const bool = !!Object.keys(this.currentItem).length
      bool ? null : await errorAdding(form)
      this.currentItem = {}
      this.dialogVisible = false
      this.getList()
      this.$message({
        message: bool ? '修改成功' : '创建成功',
        type: 'success'
      })
    },

    // 关闭
    handleClose(done) {
      this.dialogVisible = false
      this.currentItem = {}
    },

    fetchPageSizeone(e) {
      this.parameter.page_size = e
      this.getList()
    },

    fetchCurrentPageone(e) {
      this.parameter.page = e
      this.getList()
    },

    timestampToTime(timestamp) {
      var date = new Date(timestamp * 1000)// 时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + '-'
      var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
      var D = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate()) + ' '
      var h = (date.getHours() < 10 ? '0' + (date.getHours()) : date.getHours()) + ':'
      var m = (date.getMinutes() < 10 ? '0' + (date.getMinutes()) : date.getMinutes()) + ':'
      var s = (date.getSeconds() < 10 ? '0' + (date.getSeconds()) : date.getSeconds())
      return Y + M + D + h + m + s
    }
  }
}
</script>

<style scoped>
.configurationList{
   width: 95%;
   margin: 0 auto;
   margin-top: 30px;
}

.configurationList_selectionArea{
   display: flex;
   flex-wrap:wrap;
   gap:10px;
}

.configurationList_main{
   margin-top: 30px;
}

.err {
    color: #caae24;
    font-size: 14px;
    margin-right: 6px;
}

.normal {
  color: #5fc922;
  font-size: 16px;
  margin-right: 6px;
}
</style>
